import { apiClient } from '../client'
import { getRefreshToken, setTokens } from './tokenStorage'

let refreshPromise: Promise<string> | null = null

const requestNewAccessToken = async (): Promise<string> => {
    const refreshToken = getRefreshToken()

    if (!refreshToken) {
        throw new Error('No refresh token available')
    }

    const response = await apiClient('token/refresh', {
        method: 'POST',
        data: { refresh_token: refreshToken },
    })
    
    setTokens(response.data.token, response.data.refresh_token)

    return response.data.token
}

export const refreshAccessToken = (): Promise<string> => {
    if (!refreshPromise) {
        refreshPromise = requestNewAccessToken().finally(() => {
            refreshPromise = null
        })
    }

    return refreshPromise
}
